import { SvgIcon } from '@material-ui/core';

export const IconChartLine = () => {
  const pixelSize = 24;

  return (
    <SvgIcon
      width={pixelSize}
      height={pixelSize}
      viewBox={`0 0 ${pixelSize} ${pixelSize}`}
    >
      <path
        d="M2 22V2h2v18h18v2H2ZM20.486 3.126a1 1 0 0 1 .388 1.36l-5.485 9.858a1 1 0 0 1-1.732.029l-2.577-4.296-3.186 6.37a1 1 0 1 1-1.788-.894l4-8a1 1 0 0 1 1.752-.067l2.624 4.374 4.644-8.346a1 1 0 0 1 1.36-.388Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
